export default __webpack_public_path__ + "f6ceaa4738ce9772b1aceb17a53bc693.png";